import type {
  ContentEmailFieldsBasicFragment,
  ContentEmailsBoolExp,
} from "src/graphql";

/**
 * Brand-profile scoping for content-email searches, mirroring
 * `templateMatchesBrandProfile` and the backend's `appliesToFilter`
 * convention: a row with zero live (non-deleted) brand-profile assignments
 * applies to all profiles; otherwise it needs a live assignment for one of the
 * given profiles. Returns null without profiles to scope to (unscoped).
 */
export const brandProfileScopeClause = (
  brandProfileIds: readonly string[] | null | undefined,
): ContentEmailsBoolExp | null =>
  brandProfileIds
    ? {
        _or: [
          {
            _not: {
              brand_profile_assignments: {
                brand_profile: { deleted_at: { _is_null: true } },
              },
            },
          },
          {
            brand_profile_assignments: {
              brand_profile_id: { _in: [...brandProfileIds] },
              brand_profile: { deleted_at: { _is_null: true } },
            },
          },
        ],
      }
    : null;

/** The live brand profiles a content email is assigned to; empty means every profile. */
export const contentEmailBrandProfileIds = (
  email: Pick<ContentEmailFieldsBasicFragment, "brand_profile_assignments">,
): string[] =>
  email.brand_profile_assignments.flatMap(({ brand_profile }) =>
    brand_profile.deleted_at ? [] : [brand_profile.id],
  );
